import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { classNames } from 'util/classNames'
import { IconX } from '@tabler/icons-react'

export const ModalV2 = ({
  open,
  onClose,
  children,
  className,
  includePadding = true,
  includeCloseButton = false,
  preventClose = false,
}: {
  open: boolean
  onClose: () => void
  children: React.ReactNode
  className?: string
  includePadding?: boolean
  includeCloseButton?: boolean
  preventClose?: boolean
}) => {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-60"
        onClose={preventClose ? () => {} : onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={classNames(
                  className,
                  'relative transform rounded-lg bg-white text-left shadow-xl transition-all sm:w-full sm:max-w-sm',
                  includePadding ? 'px-4 pb-4 pt-5 sm:my-8 sm:p-6' : ''
                )}
              >
                {includeCloseButton && (
                  <button
                    type="button"
                    className="absolute right-2 top-2 rounded-md bg-white text-slate-400 hover:text-slate-500 focus:outline-none focus:ring-2 focus:ring-toasty-blue-500 focus:ring-offset-2"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <IconX className="h-4 w-4" aria-hidden="true" />
                  </button>
                )}
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
